import { serviceMaker } from "..";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

export const GET_ALL_SUBSCRIPTION_PACKAGE = () =>
  serviceMaker(
    API_ENDPOINTS.get_all_subscription_package.url,
    API_ENDPOINTS.get_all_subscription_package.method
  );
